import {
  clearRegistrationAuthSession,
  clearRegistrationSessionHandoff,
  getStoredRegistrationAuthSession,
  isRegistrationSessionHandoffReady,
} from '@b2b/shared'

import type { Session } from './session'

// TODO(B2B auth): Remove this localStorage token bridge after Flow and Customer
// use a platform-managed session handoff.
export const getPendingOnboardingSession = (): Session => {
  if (!isRegistrationSessionHandoffReady()) {
    return null
  }

  const registrationSession = getStoredRegistrationAuthSession()

  if (!registrationSession) {
    clearRegistrationSessionHandoff()
    return null
  }

  return {
    accessToken: registrationSession.accessToken,
    refreshToken: registrationSession.refreshToken,
    source: 'onboarding',
  }
}

export const clearOnboardingSessionHandoff = () => {
  clearRegistrationAuthSession()
  clearRegistrationSessionHandoff()
}
